export const infoTableData = [{
        serial_no: 1,
        report_style: "Value",
        min_respondants: 3,
        relation: "Customer, Direct Report, Peer, Reporting Manager, Vendor"

    }, {
        serial_no: 2,
        report_style: "Competency",
        min_respondants: 1,
        relation: "Direct Report, Peer, Reporting Manager"

    }, {
        serial_no: 3,
        report_style: "Brief Report",
        min_respondants: 1,
        relation: "Business Partner, Cousin, Customer, Direct Report, Friend, Mentee, Parent, Peer, Reporting Manager, Sibling, Son, Spouse, Teacher, Vendor"

    }, {
        serial_no: 4,
        report_style: "Vendor-Management Style",
        min_respondants: 1,
        relation: "Vendor"

    },
    {
        serial_no: 5,
        report_style: "Social Style - Spouse",
        min_respondants: 1,
        relation: "Spouse"

    },
    {
        serial_no: 6,
        report_style: "Social Style - Siblings & Cousins",
        min_respondants: 1,
        relation: "Cousin, Sibling"

    },
    {
        serial_no: 7,
        report_style: "Social Style - Business Partner",
        min_respondants: 1,
        relation: "Business Partner"
    },
    {
        serial_no: 8,
        report_style: "Social Style - Parents",
        min_respondants: 1,
        relation: "Parent"
    },
    {
        serial_no: 9,
        report_style: "Social Style - Friends",
        min_respondants: 1,
        relation: "Friend"
    },
    {
        serial_no: 10,
        report_style: "Social Style - Children",
        min_respondants: 1,
        relation: "Daughter, Son"
    },
    {
        serial_no: 11,
        report_style: "Self-Development Style",
        min_respondants: 1,
        relation: "Mentor, Teacher"
    },
    {
        serial_no: 12,
        report_style: "Overall Social Style",
        min_respondants: 1,
        relation: "Cousin, Daughter, Friend, Parent, Sibling, Son, Spouse"
    },
    {
        serial_no: 13,
        report_style: "Leadership Style",
        min_respondants: 1,
        relation: "Direct Report"
    },
    {
        serial_no: 14,
        report_style: "Execution Style",
        min_respondants: 1,
        relation: "Boss, Reporting Manager"
    },
    {
        serial_no: 15,
        report_style: "Customer-Management Style",
        min_respondants: 1,
        relation: "Customer"
    },
    {
        serial_no: 16,
        report_style: "Collaborative Style",
        min_respondants: 3,
        relation: "Peer"
    },
    {
        serial_no: 17,
        report_style: "Coaching Style",
        min_respondants: 1,
        relation: "Mentee"
    },
    {
        serial_no: 19,
        report_style: "360-Degree Feedback",
        min_respondants: 1,
        relation: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor"
    },
    // {
    //     serial_no: 20,
    //     report_style: "Role fitment report",
    //     min_respondants: 1,
    //     relation: "Boss, Business Partner, Customer, Direct Report, Mentee, Mentor, Peer, Reporting Manager, Vendor"
    // }

]


// WEBPACK FOOTER //
// ./src/new/Utils/FakeJSONs/Infotable.js